import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'null'
})

export class NullPipe implements PipeTransform {

  transform(value: string): string {
    if ( value === 'null' || value === null || value === ''){
      return '-';
    }
    return value;
  }

}
